import React from "react";
import { Typography, Box } from "@material-ui/core";
import { CircleArrowIcon } from "Components/Icons";
import { useDPTheme } from "Styles/useDPTheme";
import useStyles from "./styles";

type Props = {
  to: string;
  classOverrides?: string;
  viewTextAlign?: "right" | "bottom";
};

const CircleArrowButton = ({
  to,
  classOverrides,
  viewTextAlign = "bottom",
}: Props) => {
  const { themeSpecificColors } = useDPTheme();
  const [hovering, setHovering] = React.useState(false);
  const backgroundFill = themeSpecificColors.circleArrowBackgroundFill;

  const classes = useStyles({ hovering, backgroundFill });

  const onArrowClickHandler = () => {
    window.location.assign(to);
  };

  const hoverToggleHanlder = () => {
    setHovering(!hovering);
  };

  return (
    <Box
      className={classOverrides}
      display={"flex"}
      alignItems={"center"}
      flexDirection={viewTextAlign === "bottom" ? "column" : "row"}
      width={32}
    >
      <CircleArrowIcon
        className={`${classes.icon}`}
        onClick={onArrowClickHandler}
        hoveringFill={backgroundFill}
        hovering={hovering}
        onMouseEnter={hoverToggleHanlder}
        onMouseLeave={hoverToggleHanlder}
      />
      <Box ml={viewTextAlign === "bottom" ? 0 : 1}>
        <Typography
          color={"primary"}
          className={classes.viewText}
          align={"center"}
        >
          View
        </Typography>
      </Box>
    </Box>
  );
};

export default CircleArrowButton;
